import { createFileRoute } from '@tanstack/react-router';
import Logout from '@my-pages/features/auth/views/Logout.tsx';

export const Route = createFileRoute('/_static/logga-ut')({
    component: Logout,
});
